export class DealerInfoResponse {
  constructor(
    public cmsDealerNumber: string,
    public dealerAddress1: string,
    public dealerCity: string,
    public dealerFullName: string,
    public dealerName: string,
    public dealerPhone: string,
    public dealerState: string,
    public dealerZipCode: string,
    public status: boolean,
    public token?: string,
    public compliance?: boolean,
    public stateId?: string,
    public dealerId?: string,
    public countryCode: string = '',
  ) {
  }
}
